// 📧 src/hooks/useEmailRead.ts

import { useState } from 'react';
import { EmailReadService, getEmailConfig } from '../service/emailReadService';

export const useEmailRead = () => {
  const [loading, setLoading] = useState(false);
  const service = EmailReadService.getInstance();

  const markAsRead = async (folderPath: string, emailUids: number[]) => {
    const emailConfig = getEmailConfig();
    if (!emailConfig) {
      return { success: false, error: 'No hay configuración de email' };
    }

    setLoading(true);
    try {
      return await service.markAsRead(emailConfig, folderPath, emailUids);
    } finally {
      setLoading(false);
    }
  };

  const markAsUnread = async (folderPath: string, emailUids: number[]) => {
    const emailConfig = getEmailConfig();
    if (!emailConfig) {
      return { success: false, error: 'No hay configuración de email' };
    }

    setLoading(true);
    try {
      return await service.markAsUnread(emailConfig, folderPath, emailUids);
    } finally {
      setLoading(false);
    }
  };

  const toggleReadStatus = async (folderPath: string, emailUid: number, currentlyRead: boolean) => {
    const emailConfig = getEmailConfig();
    if (!emailConfig) {
      return { success: false, error: 'No hay configuración de email' };
    }

    setLoading(true);
    try {
      return await service.toggleReadStatus(emailConfig, folderPath, emailUid, currentlyRead);
    } finally {
      setLoading(false);
    }
  };

  return {
    markAsRead,
    markAsUnread,
    toggleReadStatus,
    loading
  };
};
